export function useEpgWidgetTracking () {
  function trackEventInDataLayer (event: string, additionalData: Record<string, unknown> = {}): void {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({ event, ...additionalData })
  }

  return { trackEventInDataLayer }
}
